module.exports = __webpack_public_path__ + "static/img/17.6a92c45c.png";